import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { AlertTriangle, X } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function CleaningAlerts() {
  const [alerts, setAlerts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAlerts = () => api.get("/notifications")
      .then((r) => setAlerts(r.data.filter((n) => n.type === "problem_cleaning" && !n.read)))
      .catch(() => {});
    fetchAlerts();
    const t = setInterval(fetchAlerts, 60000);
    return () => clearInterval(t);
  }, []);

  const dismiss = async (id, link) => {
    try { await api.post(`/notifications/${id}/read`); } catch {}
    setAlerts((prev) => prev.filter((a) => a.id !== id));
    if (link) navigate(link);
  };

  if (!alerts.length) return null;
  return (
    <div className="space-y-2" data-testid="cleaning-alerts">
      {alerts.map((a) => (
        <div key={a.id} data-testid={`cleaning-alert-${a.id}`}
             className="flex items-center gap-3 bg-amber-50 border border-amber-300 rounded-xl px-4 py-3 shadow-sm">
          <AlertTriangle className="w-5 h-5 text-amber-600 flex-shrink-0" />
          <button onClick={() => dismiss(a.id, a.link)} className="flex-1 text-left min-w-0">
            <div className="text-sm font-semibold text-amber-900">{a.title}</div>
            <div className="text-sm text-amber-800 truncate">{a.body}</div>
          </button>
          <Button size="sm" variant="ghost" onClick={() => dismiss(a.id)}
                  data-testid={`cleaning-alert-dismiss-${a.id}`}
                  className="text-amber-700 hover:bg-amber-100 flex-shrink-0">
            <X className="w-4 h-4" />
          </Button>
        </div>
      ))}
    </div>
  );
}
